// 正規表現パターン
export const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

// 英字と数字2種類以上利用し、記号の入力は !"#$%&''()\-^@[;: を許可し、８文字以上72文字以内
export const PASSWORD_REGEX = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d!"#$%&'()\-\^@[\];:]{8,72}$/;

export const NAME_KANA_REGEX = /^[ァ-ンヴー]*$/;

export const PHONE_NUMBER_REGEX = /^[0-9]{10,11}$/;

// SMS認証APIの JapanMobilePhoneNumber に合わせ、070/080/090の携帯番号だけを許可する。
// 連絡先用の PHONE_NUMBER_REGEX は固定電話・050などの既存データとの互換性を維持する。
export const SMS_PHONE_NUMBER_REGEX = /^0[789]0[0-9]{8}$/;

export const HALF_WIDTH_NUMBER_REGEX = /^[0-9]+$/;
export const HALF_WIDTH_NUMBER_WITH_DECIMAL_REGEX = /^[0-9]+(\.[0-9]+)?$/;

// 長さ制限
export const MAX_EMAIL_LENGTH = 80;
export const MAX_PASSWORD_LENGTH = 72;
export const MIN_PASSWORD_LENGTH = 8;
export const MAX_NAME_LENGTH = 15;
export const MAX_ONETIME_COST_CONTENTS_LENGTH = 100;

// 数値上限（4byte signed int）
export const MAX_SIGNED_INT_4BYTE = 2147483647;

/**
 * 数値が4byte signed intの上限以内かチェック
 * @param val 文字列形式の数値（カンマ区切り可）
 * @param max 上限値（デフォルト: 4byte signed int上限）
 */
export const isWithinIntLimit = (val: string, max = MAX_SIGNED_INT_4BYTE): boolean => {
  if (!val || val.trim() === "") return true;
  const num = Number(val.replace(/,/g, ""));
  return !isNaN(num) && num <= max;
};

/**
 * 数値が0以上かチェック（マイナス値を禁止）
 * @param val 文字列形式の数値（カンマ区切り可）
 */
export const isNonNegative = (val: string): boolean => {
  if (!val || val.trim() === "") return true;
  const num = Number(val.replace(/,/g, ""));
  return !isNaN(num) && num >= 0;
};

/**
 * 整数かチェック（小数点を禁止、カンマ区切り対応）
 * @param val 文字列形式の数値（カンマ区切り可）
 */
export const isInteger = (val: string): boolean => {
  if (!val || val.trim() === "") return true;
  return /^-?[0-9]+$/.test(val.replace(/,/g, ""));
};

// 家賃の月数として保存するカラム（礼金・敷金/更新料・手数料）の上限
export const MAX_MONTH_MULTIPLIER = 12;

/**
 * 家賃の月数（0〜MAX_MONTH_MULTIPLIER）の範囲内かチェック
 * @param val 文字列形式の数値（カンマ区切り可）
 */
export const isWithinMonthMultiplierLimit = (val: string): boolean => {
  if (!val || val.trim() === "") return true;
  const num = Number(val.replace(/,/g, ""));
  return !isNaN(num) && num <= MAX_MONTH_MULTIPLIER;
};
